import { keeper } from './utils';
import { r } from './useApi';

export const login = async (userName, password, config) => {
    const loginData = {
        userName: userName,
        password: password,
    };

    const loggedUser = await r({
        endpoint: `${keeper('apiUrl')}/v2/login`,
        method: 'post',
        sessionToken: keeper('sessionToken'),
        data: loginData,
    });

    let loggedUserFs = false;

    if (config.env.fileStorageEnabled === true) {
        loggedUserFs = await r({
            endpoint: `${keeper('fileStorageApiUrl')}/v2/login`,
            method: 'post',
            sessionToken: keeper('sessionFsToken'),
            data: loginData,
        });
    }

    if (loggedUser !== false && (loggedUserFs !== false || !config.env.fileStorageEnabled)) {
        const roleRank = getUserRank(config, loggedUser.roles);
        keeper('sessionToken', loggedUser.jwt || '');
        keeper('sessionFsToken', loggedUserFs ? loggedUserFs.jwt || '' : '');
        keeper('userName', loggedUser.userName);
        keeper('role', roleRank.role);
        keeper('rank', roleRank.rank);
        keeper('loginSource', 'login');
    }

    return loggedUser;
};

export const isLoggedIn = async (config) => {
    const loggedUser = await r({
        endpoint: `${keeper('apiUrl')}/v2/login/status`,
        sessionToken: keeper('sessionToken'),
    });

    let loggedUserFs = null;

    if (config.env.fileStorageEnabled) {
        loggedUserFs = await r({
            endpoint: `${keeper('fileStorageApiUrl')}/v2/login/status`,
            sessionToken: keeper('sessionFsToken'),
        });
    }

    if (loggedUser !== false && (loggedUserFs !== false || !config.env.fileStorageEnabled)) {
        keeper('id', loggedUser.id);
        keeper('userName', loggedUser.userName);
        keeper('role', loggedUser.role);
        keeper('loginSource', config.env.fileStorageEnabled ? 'logged' : 'logged-fs-disabled');
    } else {
        keeper('id', 0);
        keeper('userName', '');
        keeper('role', 'NONE');
        keeper(
            'loginSource',
            config.env.fileStorageEnabled ? 'not-logged' : 'not-logged-fs-disabled',
        );
    }

    return loggedUser;
};

export const getLoggedUser = () => {
    return {
        id: keeper('id') || '0',
        userName: keeper('userName') || '',
        role: keeper('role') || 'NONE',
        loginSource: keeper('loginSource') || 'preconfigured',
    };
};

export const refresh = async (apiUrl, sessionToken) => {
    return await r({
        endpoint: `${apiUrl}/login`,
        method: 'put',
        sessionToken: sessionToken,
    });
};

export const getUserRank = (config, roles) => {
    let role = 'NONE';
    let rank = 0;
    for (let _role in config.rank) {
        if (roles.includes(_role) && rank < config.rank[_role]) {
            rank = config.rank[_role];
            role = _role;
        }
    }
    return {
        role,
        rank,
    };
};

export const ping = async () => {
    return await r({
        endpoint: `${keeper('apiUrl')}/v2/ping`,
    });
};

export const resetUser = () => {
    const defaultUser = {
        id: '0',
        userName: 'NONE',
        role: 'NONE',
        loginSource: 'reset',
    };
    keeper('id', defaultUser.id);
    keeper('userName', defaultUser.userName);
    keeper('role', defaultUser.role);
    keeper('sessionToken', 'NONE');
    keeper('loginSource', defaultUser.loginSource);
    return defaultUser;
};

export const logout = async (config) => {
    const result = {
        res1: false,
        res2: false,
    };
    result.res1 = await r({
        endpoint: `${keeper('apiUrl')}/v2/login`,
        method: 'delete',
        sessionToken: keeper('sessionToken'),
    });
    if (config.env.fileStorageEnabled === true) {
        result.res2 = await r({
            endpoint: `${keeper('fileStorageApiUrl')}/v2/login`,
            method: 'delete',
            sessionToken: keeper('sessionFsToken'),
        });
    }
    if (
        (config.env.fileStorageEnabled === false && result.res1 !== false) ||
        (config.env.fileStorageEnabled === true && result.res1 !== false && result.res2 !== false)
    ) {
        resetUser();
        return result.res1;
    }
    return false;
};

export const useLogin = () => {
    return {
        isLoggedIn: isLoggedIn,
        login: login,
        refresh: refresh,
        logout: logout,
        ping: ping,
        getLoggedUser: getLoggedUser,
        getUserRank: getUserRank,
        resetUser: resetUser,
    };
};

export default useLogin;
